import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Strings from '../../../i18n';
import {
  ButtonStyled,
  ButtonStyledCancel,
  ButtonsContainer,
  InputStyled,
  TitleStyled,
  noBorderStyle
} from '../../device/addDeviceToLocation/addDeviceToLocationStyles';
import { colors } from '../../../constants/colors';
import { useGetBrandMutation } from '../../../services/device/deviceService';
import { selectCurrentUser } from '../../../store/slices/login/login';
import { ItemLocationSelected } from '../../../components/itemLocationSelected/itemLocationSelected';
import { AddLocationToBrandProps } from './addLocationToBrandProps';
import { useSetLocationBrandMutation } from '../../../services/locations/locationsService';

export const AddLocationToBrand = ({
  reloadTable,
  setOpenRightSideBar,
  location
}: AddLocationToBrandProps) => {
  const contextUser = useSelector(selectCurrentUser);
  const [filterText, setFilterText] = useState('');
  const [preLimit, setPreLimit] = useState(0);
  const [beforeLimit, setBeforeLimit] = useState(5);
  const [brandSelected, setBrandSelected] = useState(null);
  const [getBrands, { data, isSuccess: isSuccessGetBrand }] =
    useGetBrandMutation();

  const [setLocationBrand, { isSuccess }] = useSetLocationBrandMutation();

  useEffect(() => {
    getBrands({});
  }, []);

  const handleSelectBrand = () => {
    setLocationBrand({
      locationId: location.locationId,
      brandId: brandSelected
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.locations.addLocationToBrand.successSetBrand);
      setOpenRightSideBar(false);
      reloadTable();
    }
  }, [isSuccess]);

  return (
    <>
      {isSuccessGetBrand && data && (
        <Box height="100%">
          <TitleStyled variant="h5">
            {Strings.locations.addLocationToBrand.selectBrand}
          </TitleStyled>
          <Box
            height="100%"
            bgcolor={colors.white}
            padding={2}
            marginTop={3}
            borderRadius={2}
          >
            <Grid direction="row" container>
              <Typography
                fontSize={13}
                color={colors.darkGray}
                marginTop={1}
                marginLeft={2}
              >
                {Strings.locations.addLocationToBrand.searcBrand}
              </Typography>
              <Grid
                item
                xs={12}
                bgcolor={colors.lightGray}
                padding={1}
                borderRadius={2}
              >
                <InputStyled
                  sx={noBorderStyle}
                  fullWidth
                  onChange={(e) => setFilterText(e.target.value)}
                />

                {data &&
                  data.slice(preLimit, beforeLimit).map((brand: any) => (
                    <ItemLocationSelected
                      devices={brand.devicesCount}
                      selected={brand.id === brandSelected}
                      action={() => {
                        setBrandSelected(brand.id);
                      }}
                      locationName={brand.name}
                      ownerName=""
                    />
                  ))}
              </Grid>
              <Grid
                item
                container
                justifyContent="flex-end"
                marginTop={1}
                marginBottom={1}
              >
                <ButtonStyledCancel
                  disabled={preLimit === 0 && beforeLimit === 5}
                  variant="contained"
                  size="small"
                  onClick={() => {
                    setPreLimit((prev) => prev - 5);
                    setBeforeLimit((prev) => prev - 5);
                  }}
                >
                  {Strings.common.previous}
                </ButtonStyledCancel>
                <ButtonStyled
                  disabled={data && data?.length <= beforeLimit}
                  onClick={() => {
                    setPreLimit((prev) => prev + 5);
                    setBeforeLimit((prev) => prev + 5);
                  }}
                  variant="contained"
                  size="small"
                >
                  {Strings.common.next}
                </ButtonStyled>
              </Grid>
            </Grid>
            <ButtonsContainer height="10%">
              <ButtonStyledCancel
                variant="contained"
                size="large"
                onClick={() => {
                  setOpenRightSideBar(false);
                }}
              >
                {Strings.common.cancel}
              </ButtonStyledCancel>
              <ButtonStyled
                onClick={handleSelectBrand}
                variant="contained"
                size="large"
              >
                {Strings.common.select}
              </ButtonStyled>
            </ButtonsContainer>
          </Box>
        </Box>
      )}
      <div> </div>
    </>
  );
};
